import { formatFullName } from '@air/utilities';

import { type Uploader } from '~/components/Filters/UploaderFilter/UploaderFilterCard';
import { type DefaultChipType } from '~/components/Select/shared/types';

export type UploaderOption = {} & Uploader & DefaultChipType;

export const convertUploaderToOption = (uploader: Uploader): UploaderOption => ({
  ...uploader,
  value: uploader.id,
  label: formatFullName(uploader.firstName, uploader.lastName) ?? '',
});
